import React, { useContext, useEffect } from "react";
import AdminLayout from "../../components/layout/AdminLayout";
import llacFav from "../../img/LLAC-favicon.ico";
import { Helmet } from "react-helmet-async";
import RegistrationFormList from "../../components/registrationAdmin/RegistrationFormList";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const RegistrationFormListPage = () => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    getRegistrations,
    registrations,
    clearAgeFilter,
    clearSearchFilter,
    clearTableFilter,
  } = adminRegistrationContext;

  useEffect(() => {
   
    return () => {
      clearAgeFilter();
      clearSearchFilter();
      clearTableFilter();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Registration Dashboard</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          {/* <h2 className="text-center top-title">Registration Forms</h2> */}
          <RegistrationFormList
            items={registrations}
          />
        </div>
      </section>
    </AdminLayout>
  );
};

export default RegistrationFormListPage;
